import React, { useState } from "react";
import leadsnow from "../assets/leadsnow-cleaning-logo.png";
import image199 from "../assets/199.png";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppContext } from "../AppContext";
import StripeFinalCodeCheck from "./StripeFinalCodeCheck";
import { FaFacebookF } from "react-icons/fa";
import { Check } from "lucide-react";
import { X } from "lucide-react";
import ChatWidget from "./ChatWidget";
import LanguageSwitcher from "./LanguageSwitcher";
import TwoStepCheckout from "./TwoStepCheckout";
import { getLangFromPath } from "../routes";

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

const HEADER_PLAN_STRINGS = {
  en: {
    chooseWhichPlan: "Choose Which Plan Works For You",
    basic: "Basic",
    essential: "Essential",
    ultimate: "Ultimate",
    whatsIncluded: "What's Included:",
    leads: "Leads",
    marketingKit: "The Commercial Cleaning Marketing Kit",
    voiceMailScript: "Voice Mail Script",
    postcardBrochure: "Postcard & Brochure Template",
    buyNow: "Checkout",
    getStarted: "Get Started!",
    getYourListNow: "Get Your List Now",
    choosePlanBest: "Choose which plan works best for you:",
  },
  es: {
    chooseWhichPlan: "Elige el plan que mejor te funcione",
    basic: "Básico",
    essential: "Esencial",
    ultimate: "Ultimate",
    whatsIncluded: "Qué incluye:",
    leads: "Leads",
    marketingKit: "Kit de marketing de limpieza comercial",
    voiceMailScript: "Guion de buzón de voz",
    postcardBrochure: "Plantilla de postal y folleto",
    buyNow: "Finalizar compra",
    getStarted: "¡Comienza!",
    getYourListNow: "Consigue tu lista ahora",
    choosePlanBest: "Elige el plan que mejor te funcione:",
  },
};

const Header = () => {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const isSpanish = lang === "es";
  const t = HEADER_PLAN_STRINGS[lang];
  const [formData, setFormData] = useState({
    clientId: "",
    name: "",
    city: "",
    state: "",
    country: "",
    address: "",
    phone: "",
    postalCode: "",
    amount: "",
  });

  const { zipcodes, setZipcodes, buyNow, setBuyNow, loadingHeader, setSelectedPrice, leadsCount, setLeadsCount } = useAppContext();

  const [clientSecret, setClientSecret] = useState(null);
  const [amount] = useState(0); // $50 fixed
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Step 1: Triggered when form is submitted
  const handlePaymentStart = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!formData.clientId) {
      setMessage("Client ID is required.");
      return;
    }
    const amountInCents = Math.round(parseFloat(formData.amount));

    const res = await fetch(
      "https://api.usfarmdata.org/capstone/stripe?operation=create",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // userId: formData.clientId,
          clientid: formData.clientId,
          amount: amountInCents,
        }),
      }
    );

    const data = await res.json();
    if (data?.clientSecret) {
      setClientSecret(data.clientSecret);
    } else {
      setMessage("Failed to create payment intent.");
    }
  };

  // ✅ Inner Stripe Form
  const PaymentForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();

      if (!stripe || !elements) return;
      setLoading(true);


      // );
      const { error, paymentIntent } = await stripe.confirmCardPayment(
        clientSecret,
        {
          payment_method: {
            card: elements.getElement(CardElement),
            billing_details: {
              name: formData.name,
              phone: formData.phone,
              address: {
                line1: formData.address,
                city: formData.city,
                state: formData.state,
                postal_code: formData.postalCode,
                country: "US",
              },
            },
          },
        }
      );

      if (error) {
        console.error("Payment failed:", error);
        setMessage(error.message);
        setLoading(false);
        setFormData({
          name: "",
          clientId: "",
          city: "",
          state: "",
          country: "",
          address: "",
          phone: "",
          postalCode: "",
        });
        setClientSecret(null);

        return;
      }

      const amountInCents = Math.round(parseFloat(formData.amount) * 100);
      console.log(paymentIntent);
      console.log(paymentIntent?.status, "paymentIntent");
      setClientSecret(null);

      if (paymentIntent.status === "succeeded") {
        setMessage("✅ Payment successful!");

        // ✅ Save payment to your system
        await fetch(
          "https://api.usfarmdata.org/capstone/stripe?operation=save",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              // clientId: formData.clientId,
              clientid: formData.clientId,
              amount: amountInCents,
              stripedetails: {
                id: paymentIntent.id,
                status: paymentIntent.status,
                amount: paymentIntent.amount,
                currency: paymentIntent.currency,
                created: paymentIntent.created,
              },
            }),
          }
        );
        setFormData({
          name: "",
          clientId: "",
          city: "",
          state: "",
          country: "",
          address: "",
          phone: "",
          postalCode: "",
        });
        setClientSecret(null);
      }

      setLoading(false);
    };

    return (
      <form onSubmit={handleSubmit}>
        <div class="p-3 border border-gray-300 rounded bg-white my-4">
          <CardElement />
        </div>
        <button
          className="px-4 py-3 bg-[#635bff] text-white rounded font-bold cursor-pointer border-0"
          type="submit"
          disabled={loading || !stripe}
        >
          {loading ? "Processing..." : `Proceed to pay $ ${formData.amount}`}
        </button>
      </form>
    );
  };




  const plans = [
    { qty: 50, price: 39 },
    { qty: 200, price: 99 },
    { qty: 500, price: 199 },
  ];


  const PlanCard = ({ title, qty, price, items }) => {
    const { setBuyNow, setSelectedPrice, setLeadsCount, clientSecret } = useAppContext();

    const handleBuyNow = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const priceInCents = price * 100;
      setSelectedPrice(priceInCents);
      setLeadsCount(qty);
      setBuyNow('payment');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
      <div className="rounded-2xl overflow-hidden border-[3px] border-[#26A94A] shadow-2xl bg-[#D9F1F6]">
        <div className="bg-[#26A94A] text-white text-center font-bold py-4 rounded-b-2xl">
          {title}
        </div>

        <div className="px-6 py-5 text-center">
          <p className="text-[#1465B7] font-extrabold text-lg mb-3">
            {t.whatsIncluded}
          </p>

          <div className="mb-4 space-y-2">
            <h3 className="text-3xl font-extrabold text-[#EAFB55] drop-shadow-[2px_2px_0px_#2E7D32] leading-none">
              {qty}
            </h3>
            <div className="text-lg font-extrabold text-[#1465B7] leading-none">
              {t.leads}
            </div>
          </div>

          <div className="space-y-1 text-left max-w-sm mx-auto">
            {items.map((it) => (
              <div key={it.label} className="flex items-start gap-2">
                <div className="mt-[2px]">
                  {it.included ? <Check className="text-green-500 w-5 h-5 stroke-[3] mb-2" /> :
                    <X className="text-red-500 w-5 h-5 stroke-[3]" />
                  }
                </div>
                <p className="text-sm text-[#1465B7] leading-snug">{it.label}</p>
              </div>
            ))}
          </div>

          <div className="text-3xl font-extrabold text-[#26A94A] mt-5 mb-4">
            ${price}
          </div>
        </div>
        {!clientSecret && (
          <div className="space-y-4">
            <button
              type="button"
              className="w-full bg-[#FAF26B] hover:bg-yellow-300 
             border-t-2 border-l-2 border-r-2 border-b-0
             border-green-500
             rounded-t-2xl
             text-[#1465B7] font-extrabold py-5 text-lg transition cursor-pointer"
              style={{ color: "#1465B7", fontSize: "20px" }}
              onClick={handleBuyNow}
            >
              {t.buyNow}
            </button>
          </div>
        )}
        {/* <button
  type="button"
  className="w-full bg-[#FAF26B] hover:bg-yellow-300 
             border-t-2 border-l-2 border-r-2 border-b-0
             border-green-500
             rounded-t-2xl
             text-[#1465B7] font-extrabold py-5 text-lg transition"
              style={{ color: "#1465B7", fontSize: "28px" }}
>
  Buy Now
</button> */}

      </div>
    );
  };


  return (
    // <header className="relative min-h-screen bg-gradient-to-br from-cyan-200 via-blue-200 to-cyan-300 overflow-hidden">
    <header className="relative bg-gradient-to-br from-cyan-200 via-blue-200 to-cyan-300 overflow-hidden">
      <div className="px-4 pt-4 md:px-0 md:pt-0 md:absolute md:top-6 md:right-6 z-30">
        <div className="flex items-center gap-4">
          <LanguageSwitcher />
          <a
            href="https://www.facebook.com/profile.php?id=61582707424269"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-block"
            aria-label="Facebook"
          >
            <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#1877F2] shadow-lg ring-1 ring-black/10 transition-transform group-hover:scale-110 active:scale-95">
              <FaFacebookF className="text-white" size={24} />
            </div>
          </a>
        </div>
      </div>
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-16 h-16 bg-white/20 rounded-full animate-bounce"></div>
        <div className="absolute top-32 right-20 w-12 h-12 bg-white/15 rounded-full animate-bounce"></div>
        <div className="absolute bottom-20 left-1/4 w-20 h-20 bg-white/10 rounded-full animate-bounce"></div>
        <div className="absolute top-1/2 right-10 w-8 h-8 bg-white/25 rounded-full animate-bounce"></div>
        <div className="absolute bottom-32 right-1/3 w-14 h-14 bg-white/15 rounded-full animate-bounce"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 pb-8 pt-2 md:pt-8">
        <div className="block lg:flex lg:items-center max-w-5xl mx-auto">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="mb-6 lg:mb-4 flex justify-center lg:justify-start">
              <img
                src={leadsnow}
                alt="Leads Now"
                className="w-[280px] lg:w-[220px]"
              />
            </div>


            <div className="rounded-2xl mb-8">
              <h1 className="text-[#1465B7] text-[28px] font-extrabold mb-6 max-w-[400px]">
                {isSpanish ? "Haz crecer tu negocio de limpieza comercial" : "Grow Your Commercial Cleaning Business"}
                <span className="block text-3xl text-[#26A94A] mt-2">{isSpanish ? "A tu manera" : "Your Way"}</span>
              </h1>
              <p className="text-[#26A94A] text-xl mb-4 font-semibold italic max-w-[350px]">
                {isSpanish ? (
                  <>Incluye:{" "}<span className="text-[#1465B7]">Industria, metros cuadrados, contacto(s) clave, dirección postal, URL(s) y correos (cuando estén disponibles).<span className="block mt-2"><span className="text-[#26A94A] mr-1 uppercase">Todo</span> lo que necesitas para encontrar nuevos clientes.</span></span></>
                ) : (
                  <>Includes:{" "}<span className="text-[#1465B7] ">Industry, Square Footage, Key Contact(s), Mailing Address, URL(s) & Emails (where available).<span className="block mt-2"><span className="text-[#26A94A] mr-1 uppercase">Everything</span>{" "}you need to find new customers!</span></span></>
                )}
              </p>
            </div>

          </div>

          {/* Right Form – 2 Step Checkout */}
          <div id="checkout-form-anchor" className="flex-shrink-0 md:min-w-[28rem] lg:min-w-[30rem] w-full lg:w-[38rem]">
            {(buyNow === 'home' || buyNow === 'form') && (
              <div className="mt-8 lg:mt-0">
                <TwoStepCheckout lang={lang} />
              </div>
            )}

            {loadingHeader && (
              <div className="flex items-center justify-center min-h-[400px]">
                <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
              </div>
            )}

            {(buyNow === 'payment' || buyNow === 'download') && <StripeFinalCodeCheck lang={lang} />}
          </div>
        </div>
      </div>

      <div className="w-full bg-white py-8 px-4">
        <div className="mb-8">
          <h2 className="text-center text-[#1465B7] font-extrabold text-xl sm:text-2xl mb-8">
            {t.chooseWhichPlan}
          </h2>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6">
          <PlanCard
            title={t.basic}
            qty={50}
            price={39}
            items={[
              { included: false, label: t.marketingKit },
              { included: false, label: t.voiceMailScript },
              { included: false, label: t.postcardBrochure },
            ]}
          />

          <PlanCard
            title={t.essential}
            qty={200}
            price={99}
            items={[
              { included: true, label: t.marketingKit },
              { included: false, label: t.voiceMailScript },
              { included: false, label: t.postcardBrochure },
            ]}
          />

          <PlanCard
            title={t.ultimate}
            qty={500}
            price={199}
            items={[
              { included: true, label: t.marketingKit },
              { included: true, label: t.voiceMailScript },
              { included: true, label: t.postcardBrochure },
            ]}
          />
        </div>
      </div>

      <ChatWidget />
    </header>
  );
};

export default Header;
